import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import Logout from "./components/Logout"
import store from "./redux/store";
import Home from "./pages/Home";
import Wishes from "./pages/Wishes";
import Profile from "./pages/Profile"
import { useDispatch, useSelector } from "react-redux";
import { loaded } from "./redux/authSlice";
import { useEffect } from "react";

function AppContent() {
  const dispatch = useDispatch();
  const { authToken, loading } = useSelector((state) => state.auth)

  useEffect(() => {
    dispatch(loaded());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-16 h-16 border-4 border-red-500 border-dashed rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={authToken ? <Wishes /> : <Home />} />
      <Route path="/profile" element={authToken ? <Profile /> : <Home />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
